import React from 'react';
import LazyLoad from 'react-lazy-load';

import MapMapbox from './MapMapbox';

// eslint-disable-next-line react/prop-types
const LazyLoadedMapMapbox = ({ subtype, ...props }) => {
    const map = <MapMapbox {...props} />;

    // if top object, do not lazy load
    if (subtype === 'top') {
        return map;
    }

    return (
        <LazyLoad offset={500} debounce={false} throttle={100}>
            {map}
        </LazyLoad>
    );
};

export default LazyLoadedMapMapbox;



/** WEBPACK FOOTER **
 ** ./src/local-components/article/LazyLoadedMapMapbox.js
 **/